import {useState, useEffect} from 'react';
import {DashboardCard} from './utils';
import {faBolt, faHeartbeat} from '@fortawesome/free-solid-svg-icons';
import Col from 'react-bootstrap/Col';
import PulsoidSocket, {PulsoidMessageJsonResponse} from '@pulsoid/socket';
import {usePulsoidClient} from '../../PulsoidClient';

export const StreamingStatusV2 = () => {
  const [state, setState] = useState<'Opened' | 'Closed'>('Closed');
  const [heartRate, setHeartRate] = useState<PulsoidMessageJsonResponse | null>(
    null
  );
  const client = usePulsoidClient();
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    if (heartRate) {
      setState('Opened');
    }
  }, [heartRate]);

  useEffect(() => {
    async function fetch() {
      let response = await client.getDashboardToken();
      setToken(response.token);
    }
    fetch();
  }, []);

  useEffect(() => {
    if (token) {
      let pulsoid = new PulsoidSocket(token);
      pulsoid.on('heart-rate', (data) => {
        setHeartRate(data);
      });
      pulsoid.connect();

      return () => {
        pulsoid.disconnect();
      };
    }
  }, [token]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setState('Closed');
    }, 23_000);
    return () => clearTimeout(timeoutId);
  }, [heartRate]);

  return (
    <div>
      <h2 style={{borderBottom: '1px solid #eee', marginLeft: '15px'}}>
        Current status
      </h2>
      <div
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
        {state === 'Opened' && [
          <Col className="p-2" key="status">
            <DashboardCard
              type="success"
              value="Online"
              description="pulsing"
              icon={faBolt}
            />
          </Col>,
          <Col className="p-2" key="value">
            <DashboardCard
              type="info"
              value={heartRate?.heartRate}
              description="current value"
              icon={faHeartbeat}
            />
          </Col>,
        ]}
        {state === 'Closed' && [
          <Col className="p-2" key="status">
            <DashboardCard
              type="dark"
              value="Offline"
              description="pulsing"
              icon={faBolt}
            />
          </Col>,
          <Col className="p-2" key="value">
            <DashboardCard
              type="dark"
              value="--"
              description="current value"
              icon={faHeartbeat}
            />
          </Col>,
        ]}
      </div>
    </div>
  );
};
